import React from 'react'
import EditIndividualMembersForm from '../../../features/gmap/EditIndividualMembersForm/EditIndividualMembersForm'

const EditIndividualMembers = () => {
    return (<EditIndividualMembersForm />)
}

export default EditIndividualMembers